export default function takeFirstResult (data) {
  if (data.length) {
    data = data[0]
  } else {
    data = null
  }
  return data
}



// WEBPACK FOOTER //
// ./src/api/util/takeFirstResult.js